import axios from "axios";
import config from "../Utility/ConfigUtility";
import { paramsInQueryStringFormat } from "../Utility/ServiceUtility";
import { alert } from "../Components/Shared/AlertUtility";
import "../Components/Shared/TokenInterceptor";

const DataEndpoints = {
    getMetadata: pubId => axios.get(`${config.apiUrl}/metadata/${pubId}`),
    getChartData: payload => axios.post(`${config.apiUrl}/data/chart`, payload),
    getChart: (chartName, fileFolder) => axios.get(`${config.apiUrl}/charts/${encodeURIComponent(chartName)}${paramsInQueryStringFormat({ fileFolder })}`),
    getChartPermission: () => axios.get(`${config.apiUrl}/charts/permission`),
    getChartPreview: chartId => axios.get(`${config.apiUrl}/charts/${chartId}/preview`, { responseType: 'arraybuffer' }),
    getDatasets: _ => axios.get(`${config.apiUrl}/datasets`),
    getPublications: (datasetId, datasetName) => axios.get(`${config.apiUrl}/publications${paramsInQueryStringFormat({ datasetId, datasetName })}`),
    alert
};

export default DataEndpoints;